import React, { useEffect, useState } from "react";
import apiService from "~/services/service";
import API_ROUTES_V2 from "~/api-routes-v2";
import { useParams } from "react-router-dom";
import z from "zod";

const useTenantChildEntity = () => {
  const { id } = useParams();
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState(1);
  const skeletonRows = Array.from({ length: rows });
  const fetchEntities = async ({
    page = 1,
    pageSize = 10,
    sortBy = "name",
    order = "asc",
  }) => {
    try {
      setLoading(true);
      const response = await apiService(
        API_ROUTES_V2.FETCH_ENTITIES_BY_TENANT,
        "GET",
        {
          replace: {
            tenant_id: id,
            page,
            pageSize,
            sortBy,
            sortOrder: order,
          },
          schema: z.object({
            tenant_id: z.string().uuid(),
            page: z.number().optional(),
            pageSize: z.number().optional(),
            sortBy: z
              .enum(["name", "country", "type", "account_manager"])
              .optional(),
            sortOrder: z.enum(["asc", "desc"]).optional(),
          }),
        },
      );
      const entitiesData = response?.data?.entities ?? [];
      const pagination = response?.data?.pagination ?? {};
      setEntities(entitiesData);
      setTotalRecords(pagination.total ?? 0);
    } catch (error) {
      console.error("Failed to fetch tenant entities", error);
      setEntities([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;

    fetchEntities({
      page: Math.floor(first / rows) + 1,
      pageSize: rows,
      sortBy: sortField,
      order: sortOrder === 1 ? "asc" : "desc",
    });
  }, [id, first, rows, sortField, sortOrder]);

  const onPage = (e) => {
    setFirst(e.first);
    setRows(e.rows);
  };

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);
  };

  return {
    loading,
    entities,
    skeletonRows,
    totalRecords,
    first,
    rows,
    onPage,
    sortField,
    sortOrder,
    onSort,
  };
};

export default useTenantChildEntity;
